module.exports = __webpack_public_path__ + "e0106718/img/link-icon.fa09ed66.svg";